import { Routes } from '@angular/router';
import { CampagnesComponent } from './campagnes.component';

export const CAMPAGNES_ROUTES: Routes = [
    {
        path: '',
        component: CampagnesComponent,
        data: {
            role: 'ORGANISME',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.administration-campagnes',
                icon: 'key'
            }
        }
    }
];
